import { Component, OnInit } from '@angular/core';
import { Image } from '../models/image.model';
import { ActivityService } from '../services/activity.service';
import { VisitService } from '../services/visit.service';

@Component({
  selector: 'app-presentation',
  templateUrl: './presentation.component.html',
  styleUrls: ['./presentation.component.scss']
})
export class PresentationComponent implements OnInit {

  images: Image[] = [];
  responsiveOptions: any[];

  products: any[] = []

  constructor(private activitiesService: ActivityService, private visitService: VisitService) {
    this.responsiveOptions = [
      {
          breakpoint: '1024px',
          numVisible: 3,
          numScroll: 3
      },
      {
          breakpoint: '768px',
          numVisible: 2,
          numScroll: 2
      },
      {
          breakpoint: '560px',
          numVisible: 1,
          numScroll: 1
      }
  ];
  }

  ngOnInit(): void {
    this.images = [
      {
        codeTrad: 'presentation.activities.images.ble',
        cover: false,
        path: 'assets/images/presentation/ble.JPG'
      },{
        codeTrad: 'presentation.activities.images.caleche',
        cover: false,
        path: 'assets/images/presentation/caleche.jpg'
      },{
        codeTrad: 'presentation.activities.images.cheval',
        cover: false,
        path: 'assets/images/presentation/cheval.JPG'
      },{
        codeTrad: 'presentation.activities.images.chevres',
        cover: false,
        path: 'assets/images/presentation/chevres.JPG'
      },{
        codeTrad: 'presentation.activities.images.chevres2',
        cover: false,
        path: 'assets/images/presentation/chevres2.JPG'
      },{
        codeTrad: 'presentation.activities.images.chien',
        cover: false,
        path: 'assets/images/presentation/chien.JPG'
      },{
        codeTrad: 'presentation.activities.images.ferme-aerienne',
        cover: false,
        path: 'assets/images/presentation/ferme_aerienne.png'
      },{
        codeTrad: 'presentation.activities.images.pain',
        cover: false,
        path: 'assets/images/presentation/pain.JPG'
      },
    ]

    this.products.push(...this.visitService.exportCarousel());
    this.products.push(...this.activitiesService.exportCarousel());
  }

}
